import GameStateControl from "../../GameStateControl.js";
import Page from "../framework/Page";
import View from "../framework/View";
import { PageIds } from "../PageIds";

export default class SavePopupView extends View {
    /**
     * @param {string} parentId
     * @param {GameStateControl} gameStateControl
     */
    constructor(parentId, gameStateControl) {
        super(parentId, PageIds.SAVE_POPUP);

        /**
         * @constant
         * @type {GameStateControl}
         */
        this.gameStateControl = gameStateControl;

        this.setCurrentlyVisible(true);
        this.setViewVisible(false);
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);
        const savePopupElement = Page.createElement('div', parentElement, this.elementId, 'popup-window-save');

        const saveContentsElement = Page.createElement('div', savePopupElement, null, null);

        // Header: Save Controls
        const saveControlsHeader = Page.createElement('div', saveContentsElement, null, 'popup-window-header');
        saveControlsHeader.innerHTML = 'Save Controls';

        saveControlsHeader.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };
            
        const menuSectionBody = Page.createElement('div', saveContentsElement, null, 'menu-section-body'); // <div class="menu-section-body"></div>

        // <div id="lastSaveTime" >00:00 23 Aug 2016</div>
        // const lastSaveTimeElement = Page.createElement('div', menuSectionBody, null, 'menu-section-body'); 
        // lastSaveTimeElement.innerHTML = '00:00 23 Aug 2025';

        //         <div id="saveButtonsContainer" class="save-popup-buttons-container">
        //           <div id="exportSaveButton" class="game-button">
        //             Export Save
        //           </div>
        //           <div id="importSaveButton" class="game-button">
        //             Import Save
        //           </div>
        //           <div id="resetGameButton" title="Reset the current game, but not your prestige count. You will be asked to confirm." class="game-button">
        //             Reset Game
        //           </div>
        //           <div id="deleteSaveButton" title="Delete all your progress, including prestige count. You will be asked to confirm." class="game-button">
        //             Delete Save
        //           </div>
        //         </div>

        const saveButtonsContainer = Page.createElement('div', menuSectionBody, 'saveButtonsContainer', 'save-popup-buttons-container');

        const exportSaveButton = Page.createElement('div', saveButtonsContainer, 'exportSaveButton', 'game-button');
        exportSaveButton.innerHTML = 'Export Save';

        const importSaveButton = Page.createElement('div', saveButtonsContainer, 'importSaveButton', 'game-button');
        importSaveButton.innerHTML = 'Import Save';

        const resetGameButton = Page.createElement('div', saveButtonsContainer, 'resetGameButton', 'game-button');
        resetGameButton.innerHTML = 'Reset Game';

        const deleteGameButton = Page.createElement('div', saveButtonsContainer, 'deleteSaveButton', 'game-button');
        deleteGameButton.innerHTML = 'Delete Save';
        

        //         <div id="importContainer" style="display:none;">
        //           <div style="float:left;">
        //             <textarea id="importTextArea" title="Paste exported save here and click import."
        //               class="import-export-textarea"></textarea>
        //           </div>
    
        //           <div id="importButtonActual" class="game-button save-button">
        //             Import
        //           </div>
        //           <div id="closeImportButton" class="game-button save-button">
        //             Close
        //           </div>
    
        //           <div id="importResults" style="display:none;padding:10px;float:left;"></div>
        //         </div>

        //////////////////////////////////////////////////
        // Import Save
        //////////////////////////////////////////////////

        const importContainer = Page.createElement('div', menuSectionBody, 'importContainer', 'save-popup-content-container');
        importContainer.style.display = 'none';

        const importTextAreaContainer = Page.createElement('div', importContainer, null, null);
        //importTextAreaContainer.style.float = 'left';

        // <textarea id="importTextArea" title="Paste exported save here and click import." class="import-export-textarea"></textarea>
        const importTextArea = Page.createElement('textarea', importTextAreaContainer, 'importTextArea', 'import-export-textarea');
        importTextArea.title = 'Paste exported save here and click import.';

        const importButtonRow = Page.createElement('div', importTextAreaContainer, null, 'save-popup-button-row');

        // const pasteFromClipboardButton = Page.createElement('div', importButtonRow, 'pasteFromClipboardButton', 'game-button save-button');
        // pasteFromClipboardButton.style.width = '140px';
        // pasteFromClipboardButton.innerHTML = 'Paste from Clipboard';

        const importButtonActual = Page.createElement('div', importButtonRow, 'importButtonActual', 'game-button save-button');
        importButtonActual.innerHTML = 'Import';

        const closeImportButton = Page.createElement('div', importButtonRow, 'closeImportButton', 'game-button save-button');
        closeImportButton.innerHTML = 'Close';

        // // <div id="importResults" style="display:none;padding:10px;float:left;"></div>
        // const importResultsElement = Page.createElement('div', importContainer, 'importResults', null);
        // importResultsElement.style.display = 'none';
        // importResultsElement.style.padding = '10px';
        // importResultsElement.style.float = 'left';

        //////////////////////////////////////////////////
        // Export Save
        //////////////////////////////////////////////////

        const exportContainer = Page.createElement('div', menuSectionBody, 'exportContainer', 'save-popup-content-container');
        exportContainer.style.display = 'none';

        const exportTextAreaContainer = Page.createElement('div', exportContainer, null, null);

        // <textarea id="exportTextArea" class="import-export-textarea"></textarea>
        const exportTextArea = Page.createElement('textarea', exportTextAreaContainer, 'exportTextArea', 'import-export-textarea');

        const exportButtonRow = Page.createElement('div', exportContainer, null, 'save-popup-button-row');

        const copyToClipboardButton = Page.createElement('div', exportButtonRow, 'copyToClipboardButton', 'game-button save-button');
        copyToClipboardButton.style.width = '130px';
        copyToClipboardButton.innerHTML = 'Copy to Clipboard';

        const closeExportButton = Page.createElement('div', exportButtonRow, 'closeExportButton', 'game-button save-button');
        closeExportButton.innerHTML = 'Close';


        //////////////////////////////////////////////////
        // Reset Save
        //////////////////////////////////////////////////

        //         <div id="resetConfirmationContainer" style="display:none;">
        //           <div style="float:left;padding:10px;">
        //             Are you sure you want to reset? You will not lose your prestige count.
        //           </div>
    
        //           <div id="resetButtonActual" class="game-button save-button">
        //             Reset
        //           </div>
        //           <div id="closeResetButton" class="game-button save-button">
        //             Close
        //           </div>
        //         </div>

        const resetConfirmationContainer = Page.createElement('div', menuSectionBody, 'resetConfirmationContainer', 'save-popup-content-container');
        resetConfirmationContainer.style.display = 'none';

        const resetConfirmationText = Page.createElement('div', resetConfirmationContainer, null, null);
        resetConfirmationText.style.padding = '10px';
        resetConfirmationText.innerHTML = 'Are you sure you want to reset? You will not lose your victory count.';

        const resetButtonRow = Page.createElement('div', resetConfirmationContainer, null, 'save-popup-button-row');

        const resetButtonActual = Page.createElement('div', resetButtonRow, 'resetButtonActual', 'game-button save-button');
        resetButtonActual.innerHTML = 'Reset';

        const closeResetButton = Page.createElement('div', resetButtonRow, 'closeResetButton', 'game-button save-button');
        closeResetButton.innerHTML = 'Close';


        //////////////////////////////////////////////////
        // Reset Save
        //////////////////////////////////////////////////

        //         <div id="deleteConfirmationContainer" style="display:none;">
        //           <div style="float:left;padding:10px;">
        //             Are you sure you want to delete? You will lose everything and start over.
        //           </div>
    
        //           <div id="deleteButtonActual" class="game-button save-button">
        //             Delete
        //           </div>
        //           <div id="closeDeleteButton" class="game-button save-button">
        //             Close
        //           </div>
        //         </div>

        const deleteConfirmationContainer = Page.createElement('div', menuSectionBody, 'deleteConfirmationContainer', 'save-popup-content-container');
        deleteConfirmationContainer.style.display = 'none';

        const deleteConfirmationText = Page.createElement('div', deleteConfirmationContainer, null, null);
        deleteConfirmationText.style.padding = '10px';
        deleteConfirmationText.innerHTML = 'Are you sure you want to delete? You will lose everything and start over.';

        const deleteButtonRow = Page.createElement('div', deleteConfirmationContainer, null, 'save-popup-button-row');

        const deleteButtonActual = Page.createElement('div', deleteButtonRow, 'deleteButtonActual', 'game-button save-button');
        deleteButtonActual.innerHTML = 'Delete';

        const closeDeleteButton = Page.createElement('div', deleteButtonRow, 'closeDeleteButton', 'game-button save-button');
        closeDeleteButton.innerHTML = 'Close';



        //   <div id="savePopup" class="popup-window-save" style="display: none;">
        //     <div id="saveContents">
        //       <div class="popup-window-header">
        //         Save Controls
        //       </div>
        //       <div class="menu-section-body">
        //         <div id="lastSaveTime" >00:00 23 Aug 2016</div>

        //         <div id="saveButtonsContainer" class="save-popup-buttons-container">
        //           <div id="exportSaveButton" class="game-button">
        //             Export Save
        //           </div>
        //           <div id="importSaveButton" class="game-button">
        //             Import Save
        //           </div>
        //           <div id="resetGameButton" title="Reset the current game, but not your prestige count. You will be asked to confirm." class="game-button">
        //             Reset Game
        //           </div>
        //           <div id="deleteSaveButton" title="Delete all your progress, including prestige count. You will be asked to confirm." class="game-button">
        //             Delete Save
        //           </div>
        //         </div>
    
        //         <div id="importContainer" style="display:none;">
        //           <div style="float:left;">
        //             <textarea id="importTextArea" title="Paste exported save here and click import."
        //               class="import-export-textarea"></textarea>
        //           </div>
    
        //           <div id="importButtonActual" class="game-button save-button">
        //             Import
        //           </div>
        //           <div id="closeImportButton" class="game-button save-button">
        //             Close
        //           </div>
    
        //           <div id="importResults" style="display:none;padding:10px;float:left;"></div>
        //         </div>
    
        //         <div id="resetConfirmationContainer" style="display:none;">
        //           <div style="float:left;padding:10px;">
        //             Are you sure you want to reset? You will not lose your victory count.
        //           </div>
    
        //           <div id="resetButtonActual" class="game-button save-button">
        //             Reset
        //           </div>
        //           <div id="closeResetButton" class="game-button save-button">
        //             Close
        //           </div>
        //         </div>
    
        //         <div id="deleteConfirmationContainer" style="display:none;">
        //           <div style="float:left;padding:10px;">
        //             Are you sure you want to delete? You will lose everything and start over.
        //           </div>
    
        //           <div id="deleteButtonActual" class="game-button save-button">
        //             Delete
        //           </div>
        //           <div id="closeDeleteButton" class="game-button save-button">
        //             Close
        //           </div>
        //         </div>
    
        //       </div>
        //     </div>
        //   </div>

        this.setInitialVisibility(false);

        super.initializeView();

        const thisRef = this;

        this.saveTimeDiv = Page.getElement('lastSaveTime');
        this.displayedSaveTime = -1;
    
        exportSaveButton.onclick = function () {
            thisRef.displayExportSave();
            return false;
        };
    
        importSaveButton.onclick = function () {
            thisRef.displayImportSave();
            return false;
        };
    
        closeImportButton.onclick = function () {
            thisRef.closeImportContainer();
            return false;
        };
    
        importButtonActual.onclick = function () {
            thisRef.handleImportSave();
            return false;
        };


        closeExportButton.onclick = function () {
            thisRef.closeExportContainer();
            return false;
        };

        copyToClipboardButton.onclick = function() {
            exportTextArea.select();

            navigator.clipboard.writeText(exportTextArea.value).then(
                () => {
                  console.log('clipboard successfully set');
                },
                () => {
                  console.error('clipboard write failed');
                }
            );
        }

        // pasteFromClipboardButton.onclick = function() {
        //     navigator.clipboard.readText().then(text => {
        //         importTextArea.value = text;
        //     })
        //     .catch(err => {
        //       console.error('Failed to read clipboard contents: ', err);
        //     });            
        // }
    
        resetGameButton.onclick = function () {
            thisRef.displayResetConfirmation();
            return false;
        };
    
        deleteGameButton.onclick = function () {
            thisRef.displayDeleteConfirmation();
            return false;
        };
    
        resetButtonActual.onclick = function () {
            thisRef.handleGameReset();
            return false;
        };
    
        deleteButtonActual.onclick = function () {
            thisRef.handleGameDelete();
            return false;
        };
    
        closeResetButton.onclick = function () {
            thisRef.closeResetConfirmation();
            return false;
        };
    
        closeDeleteButton.onclick = function () {
            thisRef.closeDeleteConfirmation();
            return false;
        };        
    }

    /**
     */
    displayExportSave() {
        // Hide the save button container.
        Page.hideElementId('saveButtonsContainer');

        // Make the import export container visible.
        Page.showElementId('exportContainer');

        // Populate the text area with the exported save.
        var exportTextArea = Page.getElement('exportTextArea');

        const state = this.gameStateControl.getState();
        exportTextArea.value = state.saveManager.getSaveStateForExport(state);
    }

    /**
     */
    displayImportSave() {
        // Hide the save button container.
        Page.hideElementId('saveButtonsContainer');

        // Make the import export container visible.
        Page.showElementId('importContainer');

        // Make sure the import button is visible.
        Page.showElementId('importButtonActual');
    }

    /**
     */
    closeImportContainer() {
        // Clear out the contents of the text area.
        var importTextArea = Page.getElement('importTextArea');
        importTextArea.value = '';

        // Hide the import container.
        Page.hideElementId('importContainer');

        // Display the save button container.
        Page.showElementIdWithValue('saveButtonsContainer', 'grid'); // This uses 'grid' instead of 'block'
    }

    /**
     */
    closeExportContainer() {
        // Clear out the contents of the text area.
        var exportTextArea = Page.getElement('exportTextArea');
        exportTextArea.value = '';

        // Hide the import export container.
        Page.hideElementId('exportContainer');

        // Display the save button container.
        Page.showElementIdWithValue('saveButtonsContainer', 'grid'); // This uses 'grid' instead of 'block'
    }


    /**
     */
    handleImportSave() {
        console.log('SavePopupView.handleImportSave()');

        const saveStateText = Page.getElement('importTextArea').value;        

        this.gameStateControl.importSave(saveStateText);
    }

    /**
     */
    handleGameReset() {
        //this.internalDeleteReset(false);

        this.gameStateControl.resetGame();

        // Close the reset panel.
        /////////this.closeResetConfirmation();
    }

    /**
     */
    handleGameDelete() {
        ///this.internalDeleteReset(true);

        this.gameStateControl.deleteGame();

        // Close the reset panel.
        //////this.closeDeleteConfirmation();
    }

    /**
     */
    displayResetConfirmation() {
        // Hide the save button container.
        Page.hideElementId('saveButtonsContainer');

        // Show the confirmation container
        Page.showElementId('resetConfirmationContainer');
    }

    /**
     */
    displayDeleteConfirmation() {
        // Hide the save button container.
        Page.hideElementId('saveButtonsContainer');

        // Show the confirmation container
        Page.showElementId('deleteConfirmationContainer');
    }

    /**
     */
    closeResetConfirmation() {
        // Hide the confirmation container
        Page.hideElementId('resetConfirmationContainer');

        // Show the save button container.
        Page.showElementIdWithValue('saveButtonsContainer', 'grid'); // This uses 'grid' instead of 'block'
    }

    /**
     */
    closeDeleteConfirmation() {
        // Hide the confirmation container
        Page.hideElementId('deleteConfirmationContainer');

        // Show the save button container.
        Page.showElementIdWithValue('saveButtonsContainer', 'grid'); // This uses 'grid' instead of 'block'
    }

}